import { useRef } from 'react';

import { useLegalClientSaveSourcesOfIncome } from 'api/requests/onboarding/legal/useLegalClientSaveSourcesOfIncome';
import { useFilesUpload, useServerErrorNotify } from 'hooks';
import { useTranslation } from 'libs/i18n';

import { SourcesOfIncomeFormType } from '../forms/sourcesOfIncomeForm';
import { getInitialData, getSubmitData } from '../helpers/sourcesOfIncome';

import { useOnboardingContext } from './useOnboardingContext';

export const useSourcesOfIncome = () => {
  const { t } = useTranslation();
  const { goToBack, goToNext, data } = useOnboardingContext();

  const {
    error,
    loading: submitLoading,
    saveSourcesOfIncome,
  } = useLegalClientSaveSourcesOfIncome();

  const initialData = useRef(
    getInitialData(data.legalClient?.sourcesOfIncome, t)
  ).current;
  const initialValues = useRef(initialData?.values).current;

  const {
    files,
    isLoadingFile: submitDisabled,
    onRemoveFile,
    onAddFiles,
  } = useFilesUpload(initialData?.files);

  const onSubmit = async (values: SourcesOfIncomeFormType) => {
    const submitData = getSubmitData(values);
    await saveSourcesOfIncome(data.legalClient!.id, submitData);
    goToNext();
  };

  useServerErrorNotify(error);

  return {
    initialValues,
    files,
    submitLoading,
    submitDisabled,
    onSubmit,
    onAddFiles,
    onRemoveFile,
    goToBack,
  };
};
